<app-relatorio-container
    tituloRelatorio="Certificado de Inscrição"
    descricaoRelatorio="Certidão de inscrição de pessoa jurídica"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'certificado-inscricao-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6" [formGroup]="form">
            <div class="field">
                <label class="font-semibold block mb-2">UF do Assinante</label>
                <app-estado-select [(uf)]="ufAssinante" (touched)="marcarUfAssinanteTocada()" (ufChange)="alterarUfAssinante($event)"></app-estado-select>
                @if (!ufAssinante && ufAssinanteTocada) {
                    <small class="p-error mt-2" style="color: red">Selecione a UF do assinante.</small>
                }
            </div>

            <div class="field">
                <label for="assinanteObj" class="font-semibold block mb-2">Assinante</label>
                <p-select
                    id="assinanteObj"
                    formControlName="assinanteObj"
                    [options]="assinantes()"
                    optionLabel="nmSolicitante"
                    placeholder="Selecione o assinante"
                    [filter]="false"
                    (onChange)="onAssinanteChange($event.value)"
                    [loading]="loadingAssinantes()"
                    styleClass="w-full"
                    appendTo="body"
                    emptyMessage="Nenhum registro encontrado para o seu CPF nesta UF"
                ></p-select>
                @if (form.get('assinanteObj')?.invalid && form.get('assinanteObj')?.touched) {
                    <small class="p-error mt-2" style="color: red">Selecione um assinante.</small>
                }
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Certidão" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending || form.invalid || !ufAssinante"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
